import { atom } from 'jotai';
import { mobileWidth } from '../constants';

const isSmallAtom = atom<boolean>(window.innerWidth < mobileWidth);
const isLandscapeAtom = atom<boolean>(true);
const showShareModalAtom = atom<boolean>(false);

export { isSmallAtom, showShareModalAtom, isLandscapeAtom };